/**
 * The Executive View's one "waiting on the backend" treatment.
 *
 * Ruled 2026-09-07 from Brendan's in-app pass: of the four processing states, only the What-If recalculation
 * looked right — and that one is the analyst CalcStatus panel (title, info-tinted rounded box, one row per item
 * with a status icon). The other three each had their own bare spinner or checklist. Every Exec wait now renders
 * through this wrapper: rows when the caller has per-item progress (what-if calc groups, propose pipeline stages,
 * tornado groups), spinner + title inside the same tinted box otherwise. Centered and width-capped exactly like the
 * recalculation panel was.
 */
import React from 'react';
import { Box } from '@mui/material';

import { CalcStatus } from 'src/components/AgenticV2/CalcStatus';
import { CalcProgressRow } from 'src/components/AgenticV2/types';

interface ProcessingPanelProps {
  title: string;
  rows?: CalcProgressRow[];
}

const ProcessingPanel: React.FC<ProcessingPanelProps> = ({
  title,
  rows = [],
}) => (
  <Box
    sx={{
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      py: 6,
    }}
  >
    <Box sx={{ width: '100%', maxWidth: 480 }}>
      <CalcStatus title={title} rows={rows} />
    </Box>
  </Box>
);

export default ProcessingPanel;
